import PropTypes from "prop-types";
import React, { useRef } from "react";
import _ from "lodash";
import cx from "classnames";
import { Button } from "@showitinc/showit-wc";

import OverlayTrigger from "./base/OverlayTrigger";
import Tooltip from "./base/Tooltip";
import styles from "./InfoSection.module.css";

function ChatButton(props) {
  const { messages, paddingLeft, paddingRight, active, on, onClick, leftMargin = 0 } = props;

  const buttonRef = useRef(null);

  const style = {
    cursor: "pointer",
    height: "100%",
    marginLeft: leftMargin,
  };

  if (paddingLeft) {
    style.paddingLeft = paddingLeft;
  }

  if (paddingRight) {
    style.paddingRight = paddingRight;
  }

  const classes = cx({
    "control-bar-btn": true,
    active,
    "btn-on": on,
    "ic-help-button": true,
  });

  const tooltipText = _.get(props, "title", "");
  let intercomMessageCount = null;
  if (messages > 0) {
    intercomMessageCount = <span className="intercom-message-count">{messages}</span>;
  }

  let button = (
    <Button
      ref={buttonRef}
      icon-prefix="helpChat"
      variant="icon"
      iconSize="20"
      className={styles.chatButton}
      onClick={onClick}
    >
      {intercomMessageCount}
    </Button>
  );

  if (tooltipText !== "") {
    const tooltip = <Tooltip id="si-tooltip-control-bar-button">{tooltipText}</Tooltip>;
    button = (
      <OverlayTrigger overlay={tooltip} placement="top">
        {button}
      </OverlayTrigger>
    );
  }
  return (
    <div style={style} className={classes}>
      {button}
    </div>
  );
}

ChatButton.defaultProps = {
  active: false,
  on: false,
  messages: 0,
  icons: "icon icon-help-chat",
};

ChatButton.propTypes = {
  onClick: PropTypes.func,
  icons: PropTypes.string,
  active: PropTypes.bool,
  on: PropTypes.bool,
  title: PropTypes.string,
};

export default ChatButton;
